import React, { useState } from 'react'
import Select from "react-select"
import { Dropdown, Menu, Select as AntSelect } from 'antd'
import { useParams } from 'react-router-dom'

import { AiOutlineDown } from 'react-icons/ai'

import { stringifyDate, useListData, usePet, useToggle } from '../modules'

import Receive from '../components/resusable/receive'
import NewSaleItem from '../components/modals/newsaleitem'
import AddVariant from '../components/modals/addVariant'
import SaleItem from '../components/modals/saleItem'
import pluralize from 'pluralize'
import ItemGroup from '../components/modals/itemGroup'
import Confirm from '../components/resusable/confirm'
import NewItemGroup from '../components/modals/newItemGroup'

const { Option } = AntSelect

const ItemGroups = () => {
    const [string, setString] = useState('')
    const [category, setCategory] = useState()
    const [selected, setSelected] = useState()

    const [groupModal, toggleGroupModal] = useToggle()
    const [newGroupModal, toggleNewGroupModal] = useToggle()

    const [
        { loading: itemsLoading, error: itemsError, fetch: fetchItems }, 
        { list: groups }, 
        { navigate, Paginate, page, limit }
    ] = useListData('itemGroupsPaginated', { string }, { notify: true }, 'groups')
    
    const refetch = () => {
        navigate(1)
        fetchItems()
    }
    
    const viewItem = itm => {
        setSelected(itm)
        toggleGroupModal()
    }

    const [, deleteItemGroup] = usePet('deleteItemGroup', {
        id: selected?._id
    }, { notify: true, callback: (_, notif, ops) => {
        notif("Group has been deleted", ops('success'))
        refetch()
    }, manual: true })
    
    const deleteGroup = itm => {
        setSelected(itm)
        Confirm({
            title: 'Delete item group?',
            message: 'Please note that this action is not reversable',
            okText: 'Delete Item',
            onOk: deleteItemGroup
        })
    }
    
    const search = str => {
        setString(str)
        if (str?.trim().length > 2 || str.length === 0)
            refetch()
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            {
                groupModal &&
                <ItemGroup
                    group={ selected }
                    onComplete={ refetch }
                    visible={ groupModal }
                    toggle={ toggleGroupModal } />
            }
            {
                newGroupModal &&
                <NewItemGroup
                    onComplete={ refetch }
                    visible={ newGroupModal }
                    toggle={ toggleNewGroupModal } />
            }
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                {/* <ul className="flex flex-wrap justify-center sm:justify-start mb-8 sm:mb-0 -space-x-3 -ml-px" /> */}
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-inv-item"
                    type="text"
                    placeholder="Search Item Groups" />
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                    {/* Filter button */}
                    {/* <FilterButton
                        options={['prepared', 'sale items', 'service']} /> */}
                    <button onClick={toggleNewGroupModal} className="btn hisani-btn-green text-white">
                        <svg className="w-4 h-4 fill-current opacity-50 flex-shrink-0" viewBox="0 0 16 16">
                            <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                        </svg>
                        <span className="hidden xs:block ml-2">New Item Group</span>
                    </button>
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <Receive
                    error={itemsError}
                    loading={itemsLoading}
                    progress>
                    <>
                        <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                            <h2 className="font-semibold text-gray-800">Item Groups</h2>
                        </header>
                        <div className="p-3">
                            <div className="overflow-x-auto">
                                <Receive
                                    error={itemsError}
                                    loading={itemsLoading}
                                    progress>
                                    {
                                        groups.length > 0 ?
                                            <table className="table-auto w-full">
                                                {/* Table header */}
                                                <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                                    <tr>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center">No</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-left">Group</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center">Categories</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center">Created On</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center">Default Printer</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center"></div>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                {/* Table body */}
                                                <tbody className="text-sm font-medium divide-y divide-gray-100">
                                                    {
                                                        groups.map((grp, key) =>
                                                            <tr>
                                                                <td className="p-2">
                                                                    <div className="text-center">{ ((page - 1) * limit) + (key + 1) }.</div>
                                                                </td>
                                                                <td className="p-2">
                                                                    <div className="">{grp.name}</div>
                                                                </td>
                                                                <td className="p-2">
                                                                    <div className="text-center">{grp.categories?.length} { pluralize('Category', grp.categories?.length) }</div>
                                                                </td>
                                                                <td className="p-2">
                                                                    <div className="text-center">{ stringifyDate(grp.date) }</div>
                                                                </td>
                                                                <td className="p-2">
                                                                    <div className="text-center">{ grp.printer ? grp.printer.name : 'No printer selected' }</div>
                                                                </td>
                                                                <td className="p-2 text-center">
                                                                    <Dropdown
                                                                        overlay={
                                                                            <Menu>
                                                                                <Menu.Item onClick={ () => viewItem(grp) }>View</Menu.Item>
                                                                                <Menu.Item onClick={ () => deleteGroup(grp) }>Delete Group</Menu.Item>
                                                                            </Menu>
                                                                        }>
                                                                        <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                                    </Dropdown>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                </tbody>
                                            </table>
                                        :
                                            <div className="flex font-semibold text-md justify-center items-center">
                                                <h2>Please click above to add item groups</h2>
                                            </div>
                                    }
                                </Receive>
                                {Paginate}
                            </div>
                        </div>
                    </>
                </Receive>
            </div>
        </div>
    )
}

export default ItemGroups